import createIcon from '../../createIcon';

/**
 * @component @name FileUpload
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxNi41SDE1VjEwLjVIMTlMMTIgMy41TDUgMTAuNUg5VjE2LjVaTTUgMTguNUgxOVYyMC41SDVWMTguNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileUpload = createIcon('FileUpload', [
  ['path', { d: 'M9 16.5H15V10.5H19L12 3.5L5 10.5H9V16.5ZM5 18.5H19V20.5H5V18.5Z', key: 'n0wwmn' }],
]);

export default FileUpload;
